var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.gridl, false),
            [
              _c("tree", {
                attrs: {
                  "parent-tree": _vm.treeData,
                  "frame-id": _vm.frame_id,
                  types: _vm.types,
                },
                on: { frameId: _vm.getFrameId, getList: _vm.getList },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.gridr, false),
            [
              _vm.search.length > 0
                ? _c("oaFromBox", {
                    attrs: {
                      search: _vm.search,
                      alert: _vm.alertText,
                      dropdownList: _vm.dropdownList,
                      isViewSearch: false,
                      total: _vm.total,
                      title: "物资管理",
                      isAddBtn: true,
                    },
                    on: {
                      addDataFn: _vm.handleManage,
                      dropdownFn: _vm.dropdownFn,
                      confirmData: _vm.confirmData,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "v-height-flag" },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "mt10",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        height: _vm.tableHeight,
                        "row-key": "id",
                        "default-expand-all": "",
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "物资名称",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "units",
                          label: "规格型号",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cate.cate_name",
                          label: "物资分类",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "specs",
                          label: "计量单位",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "stock",
                          label: "库存数量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "used",
                          label: "领用数量",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "describe",
                          label: _vm.$t("public.operation"),
                          fixed: "right",
                          width: "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRecord(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("记录")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleStock(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("补货")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown",
                                  { staticClass: "ml10" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-dropdown-link el-button--text el-button",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("hr.more")) +
                                            "\n                  "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        staticStyle: { "text-align": "center" },
                                      },
                                      [
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleEdit(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.$t("public.edit")) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-item",
                                          {
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-fixed" },
        [
          _c("el-pagination", {
            attrs: {
              "page-size": _vm.where.limit,
              "current-page": _vm.where.page,
              "page-sizes": [15, 20, 30],
              layout: "total,sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-material", {
        ref: "addMaterial",
        attrs: { "form-data": _vm.fromData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("receive", {
        ref: "receive",
        attrs: { "form-data": _vm.receiveData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("record", { ref: "record", attrs: { "form-data": _vm.recordData } }),
      _vm._v(" "),
      _c("material-dialog", {
        ref: "materialDialog",
        attrs: { "from-data": _vm.stockData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData1,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }